<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营商申请售后</el-breadcrumb-item>
      <el-breadcrumb-item>申请退货</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择" class="select">
              <el-option label="请选择订单状态" value="-1"></el-option>
              <el-option label="已创建" value="0"></el-option>
              <el-option label="已审核" value="1"></el-option>
              <el-option label="已发货" value="2"></el-option>
              <el-option label="仓库确认收货" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择产品" class="select2">
              <el-option label="请选择产品名称" value=""></el-option>
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="statuss" label="状态" min-width="5%"></el-table-column>
          <el-table-column prop="productname" label="产品名称" min-width="5%"></el-table-column>
          <el-table-column prop="jigouname" label="机构名称" min-width="5%"></el-table-column>
          <el-table-column prop="cardnumber" label="设备编号" min-width="5%"></el-table-column>
          <el-table-column prop="logisticsname" label="物流公司(发货给仓库)" min-width="5%"></el-table-column>
          <el-table-column prop="logisticsid" label="物流单号(发货给仓库)" min-width="5%"></el-table-column>
          <el-table-column prop="createtime" label="创建时间" min-width="5%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="5%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.status == 0 && SubRule_ErpDlsReturns_ReviewTuihuo" @click="clickReviewTuihuo(scope.row)">审核退货申请</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.status == 1 && SubRule_ErpDlsReturns_SendTuihuo" @click="clicksendTuihuo(scope.row)">运营商发货</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.status == 2 && SubRule_ErpDlsReturns_SendOkTuihuo" @click="clicksendOkTuihuo(scope.row)">仓库确认收货</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 运营商发货弹出框 -->
    <el-dialog title="运营商发货" :visible.sync="SendTuihuodialog" width="30%" :close-on-click-modal="false">
      <el-form :model="SendTuihuoForm" ref="SendTuihuoFormRef" label-width="70px">
        <el-form-item label="物流公司" class="addAdminForm">
          <el-input v-model="SendTuihuoForm.logisticsname" placeholder="请输入物流公司(发货给仓库)"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="SendTuihuoForm.logisticsid" placeholder="请输入物流单号(发货给仓库)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksaveSendTuihuo">发货</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 运营商发货弹出框 end -->

    <!-- 申请退货 start -->
    <el-tab-pane label="申请退货" v-if="SubRule_ErpDlsReturns_ApplyTuihuo" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="70px">
        <el-form-item label="产品名称" class="addAdminForm">
            <el-select v-model="addForm.bomsn" placeholder="请选择产品" class="select2">
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="保修卡号" class="addAdminForm">
          <el-input v-model="addForm.cardnumber" placeholder="请输入保修卡号后8位,然后点击校验按钮"></el-input>
          <el-button type="success" plain @click="apicheckcardnumber">校验</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">申请</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 申请退货 end -->
  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyErpDlsReturnsTui',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        bomsn: '',
        cardnumber: ''
      },
      timer: '',
      // 查询
      keywords: {
        status: '-1',
        bomsn: '',
        jigouid: '-1',
        jigouname: ''
      },
      dataList: [],
      dataListnum: 0,
      SendTuihuodialog: false,
      SendTuihuoForm: {
        id: '',
        logisticsname: '',
        logisticsid: ''
      },
      selectedPageNo: 1,
      SubRule_ErpDlsReturns_ApplyTuihuo: false,
      SubRule_ErpDlsReturns_ReviewTuihuo: false,
      SubRule_ErpDlsReturns_SendTuihuo: false,
      SubRule_ErpDlsReturns_SendOkTuihuo: false
    }
  },
  mounted () {
    this.apiGetWorkprojectList()
    this.apigetDlsReturnsTuinum()
    this.apigetDlsReturnsTuilist()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_ApplyTuihuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_ApplyTuihuo = true
      }
    })

    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_ReviewTuihuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_ReviewTuihuo = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_SendTuihuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_SendTuihuo = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ErpDlsReturns_SendOkTuihuo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ErpDlsReturns_SendOkTuihuo = true
      }
    })
  },
  methods: {
    clickReviewTuihuo (row) {
      this.$confirm('是否同意运营商的退货申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apieditDlsReturnsTuishenhe(row.id)
      })
    },
    clicksendTuihuo (row) {
      this.SendTuihuodialog = true
      this.SendTuihuoForm.id = row.id
      this.SendTuihuoForm.logisticsname = ''
      this.SendTuihuoForm.logisticsid = ''
    },
    clicksendOkTuihuo (row) {
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apieditDlsReturnsTuiSendOk(row.id)
      })
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      if (!this.addForm.cardnumber) {
        this.$alert('请输入保修卡号', '提示')
        return
      }
      this.apiaddDlsReturnsTui()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksaveSendTuihuo () {
      if (!this.SendTuihuoForm.logisticsname) {
        this.$alert('请输入物流公司(发货给仓库)', '提示')
        return
      }
      if (!this.SendTuihuoForm.logisticsid) {
        this.$alert('请输入物流单号(发货给仓库)', '提示')
        return
      }
      this.apieditDlsReturnsTuiSend()
    },
    clicksearch () {
	  this.selectedPageNo = 1
      this.apigetDlsReturnsTuinum()
      this.apigetDlsReturnsTuilist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetDlsReturnsTuilist()
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype == 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetDlsReturnsTuinum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDlsReturnsTuinum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetDlsReturnsTuilist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDlsReturnsTuilist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = []
            response.data.List.filter((item1, i1) => {
              that.dataList.push({ id: item1.Id, status: item1.Status, statuss: item1.Statuss, bomsn: item1.Bomsn, productname: item1.Productname, jigouid: item1.Jigouid, jigouname: item1.Jigouname, cardnumber: item1.Cardnumber, logisticsname: item1.Logisticsname, logisticsid: item1.Logisticsid, createtime: item1.Createtime })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddDlsReturnsTui: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: this.addForm.bomsn,
        cardnumber: this.addForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddDlsReturnsTui, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apigetDlsReturnsTuinum()
            that.apigetDlsReturnsTuilist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditDlsReturnsTuishenhe: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsTuishenhe, Qs.stringify(data))
        .then(function (response) {
          that.apigetDlsReturnsTuilist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditDlsReturnsTuiSend: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.SendTuihuoForm.id,
        logisticsname: this.SendTuihuoForm.logisticsname,
        logisticsid: this.SendTuihuoForm.logisticsid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsTuiSend, Qs.stringify(data))
        .then(function (response) {
          that.apigetDlsReturnsTuilist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.SendTuihuodialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditDlsReturnsTuiSendOk: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDlsReturnsTuiSendOk, Qs.stringify(data))
        .then(function (response) {
          that.apigetDlsReturnsTuilist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apicheckcardnumber: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        cardnumber: that.addForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckCardnumberJigou, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.addForm.cardnumber = response.data.Cardnumber
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
